import { api } from 'boot/axios.js'

export async function get(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: parseUrl('/devices/orders', queryParams),
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}

export async function query(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/devices/orders',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    throw e
  }
}

function parseUrl(state, params) {
  if (state && params.id) {
    return `/${state}/${params.id}`
  }
  return `/${state}`
}
